import React from "react";

// Vision UI Dashboard PRO React layouts
import Default from "layouts/homepage";
import VerifyTrucks from "layouts/pages/verify-trucks";
import VerifyDrivers from "layouts/pages/verify-drivers";
import TrackFastag from "layouts/pages/track-fastag";

// Icons
import { IoHome } from "react-icons/io5";
import { DirectionsCar } from "@mui/icons-material";

const routes = [
  {
    type: "collapse",
    name: "Dashboards",
    key: "homepage",
    icon: <IoHome size="15px" color="inherit" />,
    collapse: [
      {
        name: "Default",
        key: "default",
        route: "/",
        component: Default,
      },
    ],
  },
  {
    type: "collapse",
    name: "Verification Services",
    key: "verification",
    icon: <DirectionsCar size="15px" color="inherit" />,
    collapse: [
      {
        name: "Verify Trucks",
        key: "verify-trucks",
        route: "/verify-vahan",
        component: VerifyTrucks,
      },
      {
        name: "Verify Drivers",
        key: "verify-drivers",
        route: "/verify-sarathi",
        component: VerifyDrivers,
      },
      {
        name: "Track Fastag",
        key: "track-fastag",
        route: "/track-fastag",
        component: TrackFastag,
      },
    ],
  }
];

export default routes;
